import type { EmailTemplateMacro } from '../types/emailTemplate';

const MACRO_PATTERN = /\{\{([A-Z0-9_]+)\}\}/gi;

export function macroToken(key: string): string {
  return `{{${key.toUpperCase()}}}`;
}

export function extractEmailTemplateMacros(...texts: string[]): string[] {
  const found = new Set<string>();

  for (const text of texts)
  {
    const pattern = new RegExp(MACRO_PATTERN.source, MACRO_PATTERN.flags);
    let match = pattern.exec(text);

    while (match)
    {
      found.add(macroToken(match[1]));
      match = pattern.exec(text);
    }
  }

  return Array.from(found).sort();
}

export function findMacroDefinition(
  token: string,
  catalog: EmailTemplateMacro[]
): EmailTemplateMacro | undefined {
  const key = token.replace(/^\{\{|\}\}$/g, '').toUpperCase();
  return catalog.find((item) => item.key === key);
}

export function filterMacroCatalog(
  catalog: EmailTemplateMacro[],
  query: string
): EmailTemplateMacro[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized)
  {
    return catalog;
  }

  return catalog.filter((item) => {
    const token = macroToken(item.key).toLowerCase();
    return (
      token.includes(normalized) ||
      item.key.toLowerCase().includes(normalized) ||
      item.label.toLowerCase().includes(normalized) ||
      item.description.toLowerCase().includes(normalized) ||
      item.group.toLowerCase().includes(normalized)
    );
  });
}

export function groupMacroCatalog(items: EmailTemplateMacro[]): Map<string, EmailTemplateMacro[]> {
  const groups = new Map<string, EmailTemplateMacro[]>();

  for (const item of items)
  {
    const current = groups.get(item.group) ?? [];
    current.push(item);
    groups.set(item.group, current);
  }

  return groups;
}
